<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss('close')">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>Verificación de correo</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid fixed>
    <div class="center">
      <div class="box">
        <img
          src="./assets/logoblack-normal.png"
          style="width: auto; max-height: 150px"
        />
        <h3 class="ion-text-center">Ingrese su código de verificación</h3>
        <p style="color: rgb(61, 61, 61)" class="ion-text-center">
          Ingresa el código de verificación enviado al correo electronico:
        </p>
        <p>{{ userData.email }}</p>

        <form (ngSubmit)="handleSubmit()" [formGroup]="verifyForm">
          <ion-item>
            <ion-input formControlName="codigo"></ion-input>
          </ion-item>
          <div class="" style="height: 25px">
            <ng-container *ngIf="(code.dirty || code.touched) && code.errors">
              <span *ngIf="code.errors?.required"
                ><ion-text color="danger" class="ion-text-center">
                  Código es requerido
                </ion-text></span
              >
            </ng-container>
          </div>

          <ion-button
            type="submit"
            expand="block"
            style="margin-top: 10px"
            [disabled]="verifyForm.invalid"
          >
            Verificar
          </ion-button>
        </form>
      </div>
      <h5 class="ion-text-center">¿Tienes Problemas?</h5>
      <ion-button expand="block" fill="clear" (click)="resendCode()">
        Reenviar código
      </ion-button>
    </div>
  </ion-grid>
</ion-content>
